import React from 'react'
import { connect } from 'react-redux'
import { bool, string } from 'prop-types'
import RefreshButton from '../RefreshSearchButton'
import { P } from './styles/LargeScreenRefreshButton'
import { withinSearchRadius } from '../../../utils/withinSearchRadius'
import { minZoomForSearch } from '../../../config'

const TextContent = ({ signs, category, theme }) => (
  <P theme={theme}>Load {category} signs</P>
)

const LargeScreenRefreshButton = ({
  signs,
  category,
  theme,
  streetViewOrCycloramaNotOpen,
  withinRadius,
  withinZoomLevel,
  notLoading,
  coordParams,
}) =>
  streetViewOrCycloramaNotOpen &&
  !withinRadius &&
  withinZoomLevel &&
  notLoading &&
  coordParams && (
    <RefreshButton cssClass="large">
      <TextContent signs={signs} category={category} theme={theme} />
    </RefreshButton>
  )

LargeScreenRefreshButton.propTypes = {
  signs: bool.isRequired,
  category: string.isRequired,
  theme: string.isRequired,
  streetViewOrCycloramaNotOpen: bool.isRequired,
  withinRadius: bool.isRequired,
  withinZoomLevel: bool.isRequired,
  coordParams: bool.isRequired,
}

const mapStateToProps = ({ signsState, spi, ui, map }) => ({
  signs: signsState.cache.signs.length > 0,
  category: spi.category[0],
  theme: spi.theme,
  streetViewOrCycloramaNotOpen: !ui.streetViewShow && !ui.cycloramaShow,
  withinRadius:
    signsState.signs.length > 0
      ? withinSearchRadius(map.cache.center, map.center)
      : false,
  withinZoomLevel: map.zoom >= minZoomForSearch,
  notLoading: !signsState.loading,
  coordParams: map.coordParams !== '',
})

export default connect(mapStateToProps)(LargeScreenRefreshButton)



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/LargeScreenRefreshButton.jsx